import moment from 'moment-timezone';

export type EventDayPreset = {
    value: string;
    label: string;
};

const DAY_PRESET_LIMIT = 20;

export function buildEventDayPresets({
    startDate,
    endDate,
    timezone,
    now,
}: {
    startDate?: string | null;
    endDate?: string | null;
    timezone?: string | null;
    now?: moment.Moment | Date | string;
}): EventDayPreset[] {
    if (!startDate || !endDate || !timezone) {
        return [];
    }

    const start = moment.tz(startDate, timezone).startOf('day');
    const end = moment.tz(endDate, timezone).startOf('day');
    const today = moment.tz(now ?? moment(), timezone).startOf('day');

    const presets: EventDayPreset[] = [];

    const todayPreset: EventDayPreset = {
        value: today.format('YYYY-MM-DD'),
        label: 'Today, ' + today.format('MMM D'),
    };

    for (let current = start.clone(); current.isSameOrBefore(end, 'day'); current.add(1, 'day')) {
        const diff = current.diff(today, 'day');

        if (diff > 0) {
            break;
        }

        if (diff === 0) {
            presets.push(todayPreset);
        } else {
            presets.push({
                value: current.format('YYYY-MM-DD'),
                label: current.format('ddd, MMM D'),
            });
        }
    }

    if (start.diff(today, 'day') > 0) {
        presets.unshift(todayPreset);
    }

    if (presets.length > DAY_PRESET_LIMIT) {
        return [];
    }

    return presets;
}

export function findMatchingDayPreset(
    customStart: string | undefined,
    customEnd: string | undefined,
    dayPresets: EventDayPreset[],
): EventDayPreset | undefined {
    if (!customStart || !customEnd) {
        return undefined;
    }

    return dayPresets.find((option) => option.value === customStart && option.value === customEnd);
}
